<div class="LiveAPINotfiicationContainer" *ngIf="LocalEnviormentWithLiveAPIWarning == true;">
  {{'LocalEnviormentWithLiveAPIWarning' | translate}}
</div>

<div class="loginBodyContainer" style="background: #f6f6f6;">
    
    <div class="overlay animated fadeIn" *ngIf="ShowCompanySelect || showLoggOffContainer || ShowAppsSelect || isSearchActive || loading" (click)="CloseDashMenu();"></div>

    <div class="NotificationCenter animated fadeInDown" *ngIf="ShowAppsSelect" style="height: auto; width: 30vw; left: 35%;">
        <div class="NotificationCenterTitle">
            {{'SelectApplication' | translate}}
        </div>
        <div class="InfoQuestionClose">
            <i class="material-icons" (click)="ShowAppsSelect = false;">close</i>
          </div>
          <div class="InfoQuestionBody" style="padding-right: 5%;">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'SelectApplication' | translate }}</mat-label>
                <mat-select name="SelectApplication" [(ngModel)]="AuxCurrentApp" [compareWith]="compareFn">
                  <mat-option *ngFor="let app of this.Applications;" [value]="app">
                    {{app.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </div>
      
          <div class="InfoQuestionCommands" style="padding-bottom: 20px;height: auto;">
            <button mat-raised-button color="primary" class="AppChangeButton" (click)="SwitchApplication();">
              <i class="material-icons">check</i>
              {{'SelectApplication' | translate}}
            </button>
          </div>
    </div>

    <div class="NotificationCenter animated fadeInDown" *ngIf="ShowCompanySelect" style="height: auto;width: 30vw;left: 35%;">
      <div class="NotificationCenterTitle">
          {{'ChangeCompany' | translate}}
      </div>
      <div class="InfoQuestionClose">
          <i class="material-icons" (click)="ShowCompanySelect = false;">close</i>
        </div>
        <div class="InfoQuestionBody" style="padding-right: 5%;">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'ChangeCompany' | translate }}</mat-label>
              <mat-select name="ChangeCompany" [(ngModel)]="AuxCompany" [compareWith]="compareFn">
                <mat-option *ngFor="let c of this.User.Rights.AssignedCompanies;" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
    
        <div class="InfoQuestionCommands" style="padding-bottom: 20px;height: auto;">
          <button mat-raised-button color="primary" class="AppChangeButton" (click)="ChangeMainCompany(this.AuxCompany);">
            <i class="material-icons">verified</i>
            {{'ChangeCompany' | translate}}
          </button>
          <button mat-raised-button color="primary" class="AppChangeButton AddNewCompanyButton" (click)="RedirectToURLWithUrlChange('dashboard/companies/add');">
            <i class="material-icons">add</i>
            {{'AddNewCompany' | translate}}
          </button>
        </div>
  </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="showLoggOffContainer">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="showLoggOffContainer = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'LogOffQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'LogOffQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="showLoggOffContainer = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.loading" mat-raised-button color="primary" class="InfoQuestionButton PrimaryButtonTheme" (click)="showLoggOffContainer = false;LogOff();">
          <i class="material-icons">logout</i>
          {{ 'Dashboard.Menu.LogOff' | translate }}
        </button>
      </div>
    </div>

    <div class="mainProgressBarSubstitute" *ngIf="this.loading != true;"></div>
    <mat-progress-bar mode="query" class="mainProgressBar" *ngIf="this.loading == true;"></mat-progress-bar>
    
    <div class="DashLeftContent">
      <div class="LoginHeadderContainer unSelectable">
        <div class="LoginERPTitle" (click)="OpenAppsSelect();">
          <p class="LoginERPTitleParagraph">
            {{ 'HOME.TITLE' | translate }}
          <i class="material-icons">cloud_queue</i>
          </p>
          <p class="LoginERPTitleLowerParagraph">
              {{CurrentApp?.Name}}
          </p>
          <div class="LoginERPTitleSignContainer">
              <i class="material-icons">keyboard_arrow_down</i>
          </div>
        </div>
      </div>

      <div class="DashMenuContainer unSelectable">
     
        <div class="MenuCompanyLogoContainer" (click)="OpenCompanySelect();">
          <img *ngIf="this.Company?.LogoPath?.length > 0;" [src]="this.BackendServiceUrl + this.Company?.LogoPath" />
        </div>

        <div class="DashMenuContainerTopButtons">
          <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management');">
            <i class="material-icons">home</i>
            <p class="DottedRow">{{'Home' | translate}}</p>
          </div>
  
          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Orders');">
            <i class="material-icons">shopping_cart</i>
            <p class="DottedRow">{{'OrdersMenu' | translate}}</p>
            <i class="material-icons" *ngIf="ShowOrdersMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowOrdersMenu != true;">keyboard_arrow_down</i>
          </div>
  
          <div *ngIf="ShowOrdersMenu" class="DashMenuSubMenu">
            <!-- <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/order/confirmation/new');">
              <i class="material-icons">add</i>
              <p class="DottedRow">{{'ConfirmOrder' | translate}}</p>
            </div> -->
            
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/order/new/order/confirmation');">
              <i class="material-icons" style="color: #298BA8;">add</i>
              <p class="DottedRow" style="color: #298BA8;">{{'NewOrder' | translate}}</p>
            </div>

            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/new/purchase/order');">
              <i class="material-icons" style="color: #f60;">add</i>
              <p class="DottedRow" style="color: #f60;">{{'NewPurchaseOrder' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/order/confirmations');">
              <i class="material-icons">insert_drive_file</i>
              <p class="DottedRow">{{'Orders' | translate}}</p>
            </div>
  
            <!-- <div class="DashMenuContainerButton">
              <i class="material-icons">add</i>
              <p class="DottedRow">{{'PurchaseOrder' | translate}}</p>
            </div> -->
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/purchase/orders');">
              <i class="material-icons">linear_scale</i>
              <p class="DottedRow">{{'POOrders' | translate}}</p>
            </div>
          </div>
    
          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Logistics');">
            <i class="material-icons">local_shipping</i>
            <p class="DottedRow">{{'Logistics' | translate}}</p>
            <i class="material-icons" *ngIf="ShowLogisticsMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowLogisticsMenu != true;">keyboard_arrow_down</i>
          </div>
  
          <div *ngIf="ShowLogisticsMenu" class="DashMenuSubMenu">
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/new/shipment');">
              <i class="material-icons">add</i>
              <p class="DottedRow">{{'NewShipment' | translate}}</p>
            </div>
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/track/shipment');">
              <i class="material-icons">location_on</i>
              <p class="DottedRow">{{'Tracking' | translate}}</p>
            </div>
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/shipments');">
              <i class="material-icons">local_shipping</i>
              <p class="DottedRow">{{'Shipments' | translate}}</p>
            </div>
             <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/carriers');">
              <span class="material-icons">pallet</span>
              <p class="DottedRow">{{'TransportCompanies' | translate}}</p>
            </div>
          </div>
  
          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Quotations');">
            <i class="material-icons">local_offer</i>
            <p class="DottedRow">{{'QuotationsMenu' | translate}}</p>
            <i class="material-icons" *ngIf="ShowQuotationsMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowQuotationsMenu != true;">keyboard_arrow_down</i>
            <div class="DashMenuContainerButtonNotificationUnsolved" *ngIf="this.UnsolvedIndividualItemsCount > 0;">{{this.UnsolvedIndividualItemsCount}}</div>
            <div class="DashMenuContainerButtonNotification" *ngIf="this.OfferRequestsPager?.TotalCount > 0;">{{this.OfferRequestsPager.TotalCount}}</div>
          </div>
  
          <div *ngIf="ShowQuotationsMenu" class="DashMenuSubMenu">
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/quotations/new');">
              <i class="material-icons">add</i>
              <p class="DottedRow">{{'NewQuotation' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/offers');">
              <i class="material-icons">insert_drive_file</i>
              <p class="DottedRow">{{'Quotations' | translate}}</p>
            </div>

            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/offer/requests');">
              <i class="material-icons">edit</i>
              <p class="DottedRow">{{'OfferRequests' | translate}}</p>
              <div class="DottedRowNotification" *ngIf="this.OfferRequestsPager?.TotalCount > 0;">{{this.OfferRequestsPager.TotalCount}}</div>
            </div>
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/individual/items/requests');">
              <i class="material-icons">list_alt</i>
              <p class="DottedRow">{{'IndividualItemsRequests' | translate}}</p>
              <div class="DottedRowNotificationUnsolved" *ngIf="this.UnsolvedIndividualItemsCount > 0;">{{this.UnsolvedIndividualItemsCount}}</div>
            </div>
          </div>

          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Partners');">
            <i class="material-icons">people_alt</i>
            <p class="DottedRow">{{'PartnersMenu' | translate}}</p>
            <i class="material-icons" *ngIf="ShowPartnersMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowPartnersMenu != true;">keyboard_arrow_down</i>
          </div>

          <div *ngIf="ShowPartnersMenu" class="DashMenuSubMenu">
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/partners/data');">
              <i class="material-icons">people_alt</i>
              <p class="DottedRow">{{'PartnersMenu' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/partners/b2b/tracking');">
              <i class="material-icons">location_on</i>
              <p class="DottedRow">{{'B2BTracking.Title' | translate}}</p>
            </div>

             <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/partners/transit/items');">
              <i class="material-icons">local_shipping</i>
              <p class="DottedRow">{{'TransitItems' | translate}}</p>
            </div>

              <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/claims');">
              <i class="material-icons">contact_support</i>
              <p class="DottedRow">{{'Support' | translate}}</p>
            </div>
          </div>
  
          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Products');">
            <i class="material-icons">sd_storage</i>
            <p class="DottedRow">{{'ProductsMenu' | translate}}</p>
            <i class="material-icons" *ngIf="ShowProductsMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowProductsMenu != true;">keyboard_arrow_down</i>
          </div>
  
          <div *ngIf="ShowProductsMenu" class="DashMenuSubMenu">
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/products/information');">
              <i class="material-icons">storage</i>
              <p class="DottedRow">{{'ProductsInformation' | translate}}</p>
            </div>

            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/products/price/control/settings');">
              <i class="material-icons">perm_data_setting</i>
              <p class="DottedRow">{{'ProductsPriceSettings' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/products/stock');">
              <i class="material-icons">account_tree</i>
              <p class="DottedRow">{{'WarehouseStock' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/products/data/import');">
              <i class="material-icons">save_alt</i>
              <p class="DottedRow">{{'DataImports' | translate}}</p>
            </div>

            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/products/special/prices');">
              <i class="material-icons">money</i>
              <p class="DottedRow">{{'SpecialPricesProducts' | translate}}</p>
            </div>
  
            <!-- <div class="DashMenuContainerButton">
              <i class="material-icons">shopping_cart</i>
              <p class="DottedRow">{{'OCProducts' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton">
              <i class="material-icons">call_made</i>
              <p class="DottedRow">{{'POProducts' | translate}}</p>
            </div> -->
          </div>
  
          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Tasks');">
            <i class="material-icons">work</i>
            <p class="DottedRow">{{'TasksMenu' | translate}}</p>
            <i class="material-icons" *ngIf="ShowTasksMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowTasksMenu != true;">keyboard_arrow_down</i>
          </div>
  
          <div *ngIf="ShowTasksMenu" class="DashMenuSubMenu">
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/newtask');">
              <i class="material-icons">add</i>
              <p class="DottedRow">{{'NewTask' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/tasks');">
              <i class="material-icons">work</i>
              <p class="DottedRow">{{'Tasks' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton">
              <i class="material-icons">autorenew</i>
              <p class="DottedRow">{{'AutomatedTasks' | translate}}</p>
            </div>
          </div>
  
          <div class="DashMenuContainerButton" (click)="OpenCloseMenu('Settings');">
            <i class="material-icons">settings</i>
            <p class="DottedRow">{{'Settings' | translate}}</p>
            <i class="material-icons" *ngIf="ShowSettingsMenu == true;">keyboard_arrow_up</i>
            <i class="material-icons" *ngIf="ShowSettingsMenu != true;">keyboard_arrow_down</i>
          </div>
  
          <div *ngIf="ShowSettingsMenu" class="DashMenuSubMenu">
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/application/settings');">
              <i class="material-icons">app_settings_alt</i>
              <p class="DottedRow">{{'AppSettings' | translate}}</p>
            </div>
  
            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/personal/settings');">
              <i class="material-icons">person</i>
              <p class="DottedRow">{{'MySettings' | translate}}</p>
              <i class="material-icons">settings</i>
            </div>

            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/configuration/settings');">
              <i class="material-icons">construction</i>
              <p class="DottedRow">{{'DataConfiguration' | translate}}</p>
            </div>

            <div class="DashMenuContainerButton" (click)="RedirectToURLWithUrlChange('/management/settings/users');">
              <i class="material-icons">construction</i>
              <p class="DottedRow">{{'ManageUsers' | translate}}</p>
            </div>
          </div>
          
        </div>
      
        <div class="DashMenuContainerBottomButtons">
          
          <div class="DashMenuContainerButton" (click)="OpenCompanySelect();" matTooltip="({{this.Company.Name}}) {{'ChangeCompany' | translate}}" matTooltipClass='neutral-tool-tip-management'>
            <i class="material-icons" style="color: #32aa3a;">verified</i>
            <p class="DottedRow">{{this.Company.Name}}</p>
          </div>

          <div class="DashMenuContainerButton" (click)="OpenAppsSelect();">
            <i class="material-icons">unfold_more</i>
            <p class="DottedRow">{{'SelectApplication' | translate}}</p>
          </div>
          <div class="DashMenuContainerButton" (click)="OpenLogOff();">
            <i class="material-icons">logout</i>
            <p class="DottedRow">{{ 'Dashboard.Menu.LogOff' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="DashContent" *ngIf="showContent == true;" [ngClass]="{'unSelectable' : this.User?.UserManagementInfo?.ManagementRights?.CurrentUIPageRights?.UICopyRights != true}">
      <router-outlet></router-outlet>
    </div>

    <div class="overlay" *ngIf="showContent != true;"></div>
</div>
  